import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.array.index-of.js';
import 'core-js/modules/es.string.search.js';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.string.match.js';
import { openPage } from '@mx/fsp-mweb-bridge';
import 'core-js/modules/es.parse-float.js';
import 'core-js/modules/es.string.trim.js';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function dateHorToChinese(value) {
  var result = value.split('-');

  if (result.length === 1) {
    return result[0];
  }

  return "".concat(result[0], "\u5E74").concat(+result[1], "\u6708").concat(result[2], "\u65E5");
}
function date(date) {
  if (typeof date !== 'string') {
    return '';
  }

  var result = dateHorToChinese(date.split(' ')[0]).split('年');
  return result[1] || result[0];
}
function currencyFormat(value) {
  value = value || 0;
  return "".concat(value).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
}
function date2Day(value) {
  var date = (value || '').split(' ')[0].split('-');

  if (!date || !date[2]) {
    return '';
  }

  return +date[2];
}
function date2Mday(value, format) {
  var date = (value || '').split(' ')[0].split('-');

  if (!date || !date[1] || !date[2]) {
    return '';
  }

  if (!format) {
    return "".concat(+date[1], "\u6708").concat(+date[2], "\u65E5");
  } else {
    return format(+date[1], +date[2]);
  }
}
function date2YMD(value) {
  var date = (value || '').split(' ')[0].split('-');

  if (!date || !date[0] || !date[1] || !date[2]) {
    return '';
  }

  return "".concat(+date[0], "\u5E74").concat(+date[1], "\u6708").concat(date[2], "\u65E5");
}
function timeFromat(dateObj) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';
  var obj = {
    'M+': dateObj.getMonth() + 1,
    'd+': dateObj.getDate(),
    'h+': dateObj.getHours(),
    'm+': dateObj.getMinutes(),
    's+': dateObj.getSeconds(),
    'q+': Math.floor((dateObj.getMonth() + 3) / 3),
    S: dateObj.getMilliseconds()
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, "".concat(dateObj.getFullYear()).substr(4 - RegExp.$1.length));
  }

  for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
    var item = _Object$keys[_i];

    if (new RegExp("(".concat(item, ")")).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? obj[item] : "00".concat(obj[item]).substr("".concat(obj[item]).length));
    }
  }

  return fmt;
}
function timeStampToYMD(timeStamp) {
  var dateObj = new Date(timeStamp);
  var dateMidType = timeFromat(dateObj);
  return date2YMD(dateMidType);
}
function timeStampToMD(timeStamp) {
  var dateObj = new Date(timeStamp);
  var dateMidType = timeFromat(dateObj);
  return date2Mday(dateMidType);
}
function obj2Url(obj) {
  return Object.keys(obj).map(function (v) {
    return "".concat(v, "=").concat(obj[v]);
  }).join('&');
}
function timeStampFormat(stamp) {
  var time = new Date(+stamp);
  var year = String(time.getFullYear());
  var month = String(time.getMonth() + 1);
  var day = String(time.getDate());
  var hour = String(time.getHours());
  var min = String(time.getMinutes());
  var sec = String(time.getSeconds());
  month = Number(month) > 9 ? month : "0".concat(month);
  day = Number(day) > 9 ? day : "0".concat(day);
  min = Number(min) > 9 ? min : "0".concat(min);
  sec = Number(sec) > 9 ? sec : "0".concat(sec);
  hour = Number(hour) > 9 ? hour : "0".concat(hour);
  return "".concat(year, ".").concat(month, ".").concat(day, " ").concat(hour, ":").concat(min, ":").concat(sec);
}
function getCookie(name) {
  var nameEQ = "".concat(name, "=");
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) === 0) {
      return unescape(c.substring(nameEQ.length, c.length));
    }
  }

  return '';
}
function getUrlFrom() {
  return decodeURIComponent((/from=([^&]+)/.exec(location.search) || ['', '/'])[1]);
}
function setCookie(name, value, domain, seconds) {
  seconds = seconds || 30 * 24 * 60 * 60;
  var host = location.hostname.split('.');
  domain = domain || (host.length > 1 ? '.' : '') + host.slice(-2).join('.');
  var expires = '';

  if (seconds !== 0) {
    var _date = new Date();

    _date.setTime(_date.getTime() + seconds * 1000);

    expires = "; expires=".concat(_date.toUTCString());
  }

  document.cookie = "".concat(name, "=").concat(escape(value)).concat(expires, "; Domain=").concat(domain, "; path=/");
}
function clearCookie(name) {
  setCookie(name, '', -1);
}
function appendQuery(url, key, value) {
  if (url.indexOf('?') === -1) {
    url += '?';
  } else {
    url += '&';
  }

  url += "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
  return url;
}
function appendUrlSearch(url) {
  var search = location.search;

  if (url.indexOf('?') !== -1) {
    url += "&".concat(search.substring(1));
  } else {
    url += search;
  }

  return url;
}
function getParamFromSearch(key) {
  var params = {};

  if (location.search) {
    location.search.substring(1).split('&').forEach(function (it) {
      var arr = it.split('=');
      params[arr[0]] = arr[1];
    });
  }

  return decodeURIComponent(params[key] || '');
}
function getParamFromUrl(url, key) {
  var params = {};
  var index = url.indexOf('?');
  var search;

  if (index > -1) {
    search = url.substr(index + 1);
    search.split('&').forEach(function (it) {
      var arr = it.split('=');
      params[arr[0]] = arr[1];
    });
  }

  return decodeURIComponent(params[key] || '');
}
function getAppCode(ua) {
  var code = -1;

  if (/meituangroup/i.test(ua) || /mt\//i.test(ua)) {
    code = 0;
  } else if (/dianping/i.test(ua)) {
    code = 11;
  } else if (/waimai/i.test(ua)) {
    code = 4;
  } else if (/qcsc/i.test(ua)) {
    code = 35;
  } else if (/phoenix/i.test(ua)) {
    code = 30;
  } else if (/retail/i.test(ua)) {
    code = 31;
  } else {
    code = -1;
  }

  return code;
}
function getAppCodeForAD(appName) {
  var code = 0;

  if (/meituangroup/i.test(appName)) {
    code = 1;
  } else if (/dianping/i.test(appName)) {
    code = 2;
  } else if (/waimai/i.test(appName)) {
    code = 3;
  } else if (/qcsc/i.test(appName)) {
    code = 5;
  }

  return code;
}
function getPlatform(ua) {
  if (_typeof(ua) === 'object') {
    ua = JSON.stringify(ua);
  }

  if (/micromessenger/i.test(ua)) {
    return 11;
  } else if (/android/i.test(ua)) {
    return 4;
  } else if (/(ipad|iphone|ipod).*os\s([\d_]+)/i.test(ua)) {
    return 5;
  }

  return null;
}
var getAppType = function getAppType(ua) {
  var type = '';

  if (/arm.moma/i.test(ua)) {
    type = 'pangu';
  } else if (/com.dianping.crm/i.test(ua) || /dpcrm/i.test(ua)) {
    type = 'apollo';
  } else if (/meituanwaimai_bee/i.test(ua)) {
    type = 'mifeng';
  } else if (/meituanwaimaibusiness/i.test(ua) || /meituanwaimai-b/i.test(ua)) {
    type = 'waimaibusiness';
  } else if (/xm\//i.test(ua)) {
    type = 'daxiang';
  } else if (/meituangroup/i.test(ua) || /mt\//i.test(ua)) {
    type = 'meituan';
  } else if (/dianping/i.test(ua)) {
    type = 'dianping';
  } else if (/waimai/i.test(ua)) {
    type = 'waimai';
  } else if (/qcsc/i.test(ua)) {
    type = 'dache';
  } else if (/phoenix/i.test(ua)) {
    type = 'zhenguo';
  } else if (/retail/i.test(ua)) {
    type = 'xiaoxiang';
  }

  return type;
};
var debounce = function debounce(fn, wait) {
  var timeout = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeout !== null) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(function () {
      fn.apply(null, args);
    }, wait);
  };
};
var throttle = function throttle(fn, wait) {
  wait = wait || 0;
  var timerId;

  function throttled() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }

    timerId = setTimeout(function () {
      fn.apply(null, args);
    }, wait);
  }

  return throttled;
};
var getMobileSystem = function getMobileSystem() {
  if (/iphone/gi.test(navigator.userAgent) && window.screen.height >= 812) {
    return 'iphone';
  } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(navigator.userAgent)) {
    return 'iphone';
  } else {
    return 'android';
  }
};
var checkMobileType = function checkMobileType() {
  if (typeof window.__CLIENT === 'undefined') {
    return '';
  }

  if (/iphone/gi.test(navigator.userAgent) && window.screen.height >= 812) {
    return 'iphoneX';
  } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(navigator.userAgent)) {
    return 'iphoneNormal';
  } else if (/dianping/i.test(navigator.userAgent)) {
    return 'androidDP';
  } else {
    return 'android';
  }
};
var jumpWithStamp = function jumpWithStamp(url, native, notitlebar) {
  if (native) {
    openPage(url, function () {});
  } else {
    location.href = url;
  }
};
var jumpUrl = function jumpUrl(url) {
  openPage(url, function () {});
};
var replaceWithStamp = function replaceWithStamp(url, native, notitlebar) {
  if (native) {
    openPage(url, function () {});
  } else {
    location.replace(url);
  }
};
var formatEndDate = function formatEndDate(time) {
  var date = timeStampFormat(time);
  date = date.split(' ')[0];
  var dateAry = date.split('.');
  return "".concat(Number(dateAry[1]), "\u6708").concat(Number(dateAry[2]), "\u65E5");
};
var getAppEnv = function getAppEnv(ua) {
  return {
    isInWeixin: /micromessenger/i.test(ua),
    isInIos: /(ipad|iphone|ipod).*os\s([\d_]+)/i.test(ua),
    isInAndroid: /android/i.test(ua)
  };
};
var stringFormat = function stringFormat(str) {
  for (var _len3 = arguments.length, param = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    param[_key3 - 1] = arguments[_key3];
  }

  if (!str || !param || param.length === 0) return str;
  var s = str;

  for (var i = 0; i < param.length; i++) {
    s = s.replace(new RegExp("\\{".concat(i, "\\}"), 'g'), param[i]);
  }

  return s;
};
var replaceUrlParams = function replaceUrlParams(url, key, val) {
  if (!url) {
    return '';
  }

  if (!key) {
    return url;
  }

  var pattern = "".concat(key, "=([^&]*)");
  var replaceText = "".concat(key, "=").concat(val);
  var replace = "(".concat(key, "=)([^&]*)");
  return url.match(pattern) ? url.replace(new RegExp(replace, 'g'), replaceText) : url.match('[\?]') ? "".concat(url, "&").concat(replaceText) : "".concat(url, "?").concat(replaceText);
};
var random = function random() {
  return Math.random().toString(36).slice(-8);
};
var isEmptyObj = function isEmptyObj(obj) {
  return obj ? Object.keys(obj).length === 0 : false;
};
var calcuText = function calcuText(data, patternConfig) {
  try {
    var text = patternConfig.pattern;
    patternConfig.items.forEach(function (i, index) {
      var value = 0;

      if (_typeof(i) === 'object' && i.calc && i.key) {
        value = data[i.key] / i.calc;
      } else {
        value = data[i];
      }

      text = text.replace("{".concat(index, "}"), value || 0);
    });
    return text;
  } catch (error) {
    return '';
  }
};
var getDeviceType = function getDeviceType() {
  if (/iphone/gi.test(navigator.userAgent) && window.screen.height >= 812) {
    return 'iphoneX';
  } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(navigator.userAgent)) {
    return 'iphoneNormal';
  } else {
    return 'android';
  }
};
var GRE = 1;
var LESS = -1;
var EQU = 0;

function _stringCompare() {
  var str1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';
  var str2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';

  if (str1 === str2) {
    return EQU;
  }

  var num1 = Number(str1);
  var num2 = Number(str2);

  if (isNaN(num1) || isNaN(num2)) {
    return str1 > str2 ? GRE : LESS;
  }

  return num1 > num2 ? GRE : LESS;
}

var versionCompare = function versionCompare() {
  var baseVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var result = 0;
  var baseArr = baseVersion.split('.');
  var versionArr = version.split('.');

  if (baseArr.length === 0 && versionArr.length === 0) {
    return EQU;
  } else if (baseArr.length === 0) {
    return LESS;
  } else if (versionArr.length === 0) {
    return GRE;
  }

  var maxLen = Math.max(baseArr.length, versionArr.length);

  for (var i = 0; i < maxLen; i++) {
    result = _stringCompare(baseArr[i], versionArr[i]);

    if (result !== EQU) {
      break;
    }
  }

  return result;
};
var getPercent = function getPercent(num, total) {
  if (num === 0 || total === 0) {
    return 0;
  }

  return Math.round(num / total * 10000) / 100.00;
};
var isPhoneNumber = function isPhoneNumber(phone) {
  return /^1\d{10}$/.test(phone);
};
function pxToRem(px) {
  if (px) {
    return "".concat((px / 100).toFixed(2), "rem");
  } else {
    return px;
  }
}

function getUrlQuery() {
  var urlQueryMap = {};
  var search = location.search;

  if (search) {
    var queryArr = search.slice(1).split('&');
    queryArr.forEach(function (item) {
      var query = item.split('=');
      urlQueryMap[query[0]] = decodeURIComponent(query[1]);
    });
  }

  return urlQueryMap;
}
function unFixBody() {
  document.body.style.overflow = 'auto';
  document.body.style.position = 'static';
}
function fixBody() {
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
}
function isBase64(content) {
  return content.indexOf('data:image') === 0;
}
function EHShow() {
  try {
    if (!window.alreadyEHShow) {
      KNB && KNB.ready(function () {
        KNB.use('eh.show');
      });
      window.alreadyEHShow = true;
    }
  } catch (e) {
    throw new Error(e);
  }
}

var ls = window.localStorage;
var LS = {
  set: function set(key, value) {
    if (ls) {
      try {
        ls.setItem(key, value);
        return true;
      } catch (e) {
        console.error(e);
      }
    }

    return false;
  },
  get: function get(key) {
    return ls ? ls.getItem(key) : void 0;
  },
  remove: function remove(key) {
    ls && ls.removeItem(key);
  }
};

export { EHShow, LS, appendQuery, appendUrlSearch, calcuText, checkMobileType, clearCookie, currencyFormat, date, date2Day, date2Mday, date2YMD, dateHorToChinese, debounce, fixBody, formatEndDate, getAppCode, getAppCodeForAD, getAppEnv, getAppType, getCookie, getDeviceType, getMobileSystem, getParamFromSearch, getParamFromUrl, getPercent, getPlatform, getUrlFrom, getUrlQuery, isBase64, isEmptyObj, isPhoneNumber, jumpUrl, jumpWithStamp, obj2Url, pxToRem, random, replaceUrlParams, replaceWithStamp, setCookie, stringFormat, throttle, timeFromat, timeStampFormat, timeStampToMD, timeStampToYMD, unFixBody, versionCompare };
